import { useSelector } from 'react-redux';

const RIGHT = 'RIGHT';
const LEFT = 'LEFT';

const cabane = {
  GET: 'cabane',
};

const works = {
  LIST: 'works',
  GET: 'works',
};

const otherProjects = {
  LIST: 'other-projects',
  GET: 'other-projects',
};

const contact = {
  GET: 'contact',
};

const home = {
  LIST: 'home',
};

const version = {
  ENDPOINT: 'publish-version',
};

const OptionItem = (props) => {
  const { language } = useSelector((state) => state.config);
  return props.label[language];
};

const nav_options = [
  {
    place: LEFT,
    value: '/',
    label: (
      <OptionItem label={{ gr: 'Kleopatra Tsali', en: 'Kleopatra Tsali' }} />
    ),
  },
  {
    place: RIGHT,
    value: '/works',
    label: <OptionItem label={{ gr: 'work', en: 'work' }} />,
  },
  {
    place: RIGHT,
    value: '/other-projects',
    label: (
      <OptionItem
        label={{ gr: 'morus project', en: 'morus project' }}
      />
    ),
  },
  {
    place: RIGHT,
    value: '/cabane',
    label: <OptionItem label={{ gr: 'cabane', en: 'cabane' }} />,
  },
  {
    place: RIGHT,
    value: '/contact',
    label: <OptionItem label={{ gr: 'contact', en: 'contact' }} />,
  },
];

export {
  otherProjects,
  works,
  home,
  contact,
  version,
  cabane,
  nav_options,
  RIGHT,
  LEFT,
};
